import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck, Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        // Fallback bearer storage for environments where 3rd-party cookies get blocked
        // Note: session_token also set as httpOnly cookie by the backend.
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090d16] grid-overlay">
      <div className="flex flex-col items-center gap-4 p-8 rounded-2xl bg-[#111726] border border-slate-800">
        <ShieldCheck className="w-10 h-10 text-emerald-400" />
        <div className="flex items-center gap-3 text-slate-200">
          <Loader2 className="w-4 h-4 animate-spin text-emerald-400" />
          <span className="font-mono text-sm">Oturum doğrulanıyor...</span>
        </div>
      </div>
    </div>
  );
}
